import { render, staticRenderFns } from "./SharePostModal.vue?vue&type=template&id=05c4a51d&scoped=true&"
import script from "./SharePostModal.vue?vue&type=script&lang=ts&"
export * from "./SharePostModal.vue?vue&type=script&lang=ts&"
import style0 from "./SharePostModal.vue?vue&type=style&index=0&id=05c4a51d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c4a51d",
  null
  
)

export default component.exports